import {MENU} from "../../constants/menu";

export function setSectionId(data) {
  return {
    type: MENU.SCROLL_TO_VIEW.MAIN,
    data
  }
}
